import {OxygenError} from '../types.js';

export const DeploymentInitiateQuery = `
  mutation DeploymentInitiate($buildId: ID, $environment: EnvironmentSelectorInput, $labels: [String!], $files: [FileInput!]!) {
    deploymentInitiate(buildId: $buildId, environment: $environment, labels: $labels, files: $files) {
      deployment {
        id
      }
      deploymentTargets {
        filePath
        fileSize
        uploadUrl
        fileType
        parameters {
          name
          value
        }
      }
      deploymentConfiguration {
        timeoutInSeconds
      }
      userErrors {
        message
      }
    }
  }
`;

export interface DeploymentInitiateQueryData {
  deploymentInitiate: DeploymentInitiateResponse;
}

export interface DeploymentInitiateResponse {
  deployment: Deployment;
  deploymentTargets: DeploymentTargetResponse[];
  deploymentConfiguration: DeploymentConfigurationResponse;
  userErrors: OxygenError[];
}

export interface DeploymentTargetResponse {
  filePath: string;
  fileSize: number;
  uploadUrl: string;
  fileType: string;
  parameters: DeploymentInitiateParameters[] | null;
}

export interface DeploymentConfigurationResponse {
  timeoutInSeconds: number;
}

interface Deployment {
  id: string;
}

interface DeploymentInitiateParameters {
  name: string;
  value: string;
}
